export * from './useProductDetailsRemoteData';
